import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Disabled from '../Disabled/Disabled'
import styles from './text.scss'

export const SIZES = ['small', 'medium', 'large']

const Text = (props) => {
  const {
    label,
    title,
    size,
    highlight,
    center,
    strong,
    color,
    light,
    link,
    margin,
    width,
    block,
    className,
    onClick,
    disabled,
    children,
    labelFontSize,
    labelLineHeight,
    labelSymbol,
    labelSub,
    labelIcon,
    topLabel,
    topLabelFontSize,
    topLabelLineHeight,
    bottomLabel,
    bottomLabelFontSize,
    bottomLabelLineHeight
  } = props

  const labelClass = classNames(styles.label, {
    [styles[size]]: size,
    [styles.strong]: strong
  })

  const labelStyle = {}

  if (labelFontSize) labelStyle.fontSize = labelFontSize

  if (labelLineHeight) labelStyle.lineHeight = labelLineHeight

  if (color) labelStyle.color = color

  const topLabelStyle = {}

  if (topLabelFontSize) topLabelStyle.fontSize = topLabelFontSize

  if (topLabelLineHeight) topLabelStyle.lineHeight = topLabelLineHeight

  const bottomLabelStyle = {}

  if (bottomLabelFontSize) bottomLabelStyle.fontSize = bottomLabelFontSize

  if (bottomLabelLineHeight) bottomLabelStyle.lineHeight = bottomLabelLineHeight

  const textClass = classNames(styles.text, className, {
    [styles.title]: title,
    [styles.center]: center,
    [styles.block]: block,
    [styles.highlight]: highlight,
    [styles.link]: link,
    [styles.light]: light,
    [styles.onClick]: onClick,
    [styles.disabled]: disabled
  })

  const textStyle = {}

  if (margin) textStyle.margin = margin

  if (width) textStyle.width = width

  const content = (
    <div
      className={textClass}
      style={textStyle}
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex="0"
    >
      {topLabel && (
        <div className={styles.topLabel} style={topLabelStyle}>
          {topLabel}
        </div>
      )}

      <div className={labelClass}>
        {labelIcon && (
          <img className={styles.labelIcon} src={labelIcon} alt={label} />
        )}

        <div className={styles.labelContent} style={labelStyle}>
          {label}
        </div>

        {labelSub && <div className={styles.labelSub}>{labelSub}</div>}

        {labelSymbol && <div className={styles.labelSymbol}>{labelSymbol}</div>}
      </div>

      <div>{children}</div>

      {bottomLabel && (
        <div className={styles.bottomLabel} style={bottomLabelStyle}>
          {bottomLabel}
        </div>
      )}
    </div>
  )

  return disabled ? (
    <Disabled cursor onClick={onClick} disabled={disabled}>
      {content}
    </Disabled>
  ) : (
    content
  )
}

Text.defaultProps = {
  title: null,
  size: null,
  center: false,
  margin: null,
  width: null,
  strong: false,
  color: null,
  light: false,
  highlight: false,
  link: false,
  block: false,
  disabled: false,
  className: null,
  onClick: null,
  label: null,
  children: null,
  labelSymbol: null,
  labelSub: null,
  labelIcon: null,
  labelFontSize: null,
  labelLineHeight: null,
  topLabel: null,
  topLabelFontSize: null,
  topLabelLineHeight: null,
  bottomLabel: null,
  bottomLabelFontSize: null,
  bottomLabelLineHeight: null
}

const {
  bool,
  element,
  func,
  oneOf,
  oneOfType,
  string,
  number,
  node
} = PropTypes

Text.propTypes = {
  title: bool,
  size: oneOf(SIZES),
  margin: string,
  width: string,
  center: bool,
  strong: bool,
  color: string,
  light: bool,
  highlight: bool,
  disabled: bool,
  link: bool,
  block: bool,
  className: string,
  onClick: func,
  label: oneOfType([string, number, element, node]),
  children: PropTypes.oneOfType([string, number, element, node]),
  labelSymbol: PropTypes.oneOfType([string, element, node]),
  labelSub: PropTypes.oneOfType([string, number, element, node]),
  labelIcon: string,
  labelFontSize: string,
  labelLineHeight: string,
  topLabel: string,
  topLabelFontSize: string,
  topLabelLineHeight: string,
  bottomLabel: string,
  bottomLabelFontSize: string,
  bottomLabelLineHeight: string
}

export default Text
